import { NavLink, Outlet } from "react-router-dom";
import { Map, Inbox, LayoutGrid, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "./AuthContext";
import { Logo } from "../components/site/Navbar";
import useSeo from "../lib/useSeo";

const LINKS = [
  { to: "/admin", label: "Tours", Icon: Map, end: true },
  { to: "/admin/inquiries", label: "Inquiries", Icon: Inbox },
  { to: "/admin/content", label: "Content & Settings", Icon: LayoutGrid },
];

export default function AdminLayout() {
  useSeo({ title: "Admin | Wandervibe Journeys", description: "", path: "/admin", noindex: true });
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F8FAFC] lg:grid lg:grid-cols-[240px_1fr]">
      <aside className="border-b border-slate-200 bg-white p-5 lg:sticky lg:top-0 lg:h-screen lg:border-b-0 lg:border-r">
        <Logo />
        <nav className="mt-6 flex gap-1 overflow-x-auto lg:mt-10 lg:flex-col">
          {LINKS.map(({ to, label, Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) => `flex shrink-0 items-center gap-2 rounded-xl px-3 py-2.5 text-sm font-semibold ${isActive ? "bg-[#FFF3EC] text-[#FD691B]" : "text-slate-600 hover:bg-slate-50"}`}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
          <a href="/" target="_blank" rel="noreferrer" className="flex shrink-0 items-center gap-2 rounded-xl px-3 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50"><ExternalLink className="h-4 w-4" />View site</a>
        </nav>
        <div className="mt-6 hidden border-t border-slate-100 pt-4 text-xs text-slate-500 lg:block">{user?.email}</div>
        <button onClick={logout} className="mt-3 flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-red-600" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" />Sign out</button>
      </aside>
      <main className="min-w-0 p-5 md:p-8"><Outlet /></main>
    </div>
  );
}
